/**
 * @see LineItemDataType corresponds to src\server\routes\app\detail\payment\v2\enums\lineItemDataType.ts
 */
var LineItemDataType;
(function (LineItemDataType) {
    //STANDART = 'standart',
    LineItemDataType[LineItemDataType["NON_CTL_SO"] = 'non_ctl_so'] = "NON_CTL_SO";
    LineItemDataType[LineItemDataType["CTL_SO_24_INC"] = 'ctl_so_24_inc'] = "CTL_SO_24_INC";
    LineItemDataType[LineItemDataType["CTL_SO_24_PLUS"] = 'ctl_so_24_plus'] = "CTL_SO_24_PLUS";
    LineItemDataType[LineItemDataType["CTL_SO_24_PLUS_ONLY"] = 'ctl_so_24_plus_only'] = "CTL_SO_24_PLUS_ONLY";
})(LineItemDataType || (LineItemDataType = {}));
var tableBind = { item: '=', data: '=' };
var TableController = (function () {
    function TableController(topic) {
        this.topic = topic;
        this.OPP_VERSION_4 = 4;
        this.preferredCurrency = this.topic.calculation.currencyData.preferredCurrency;
        this.orderCurrency = this.topic.calculation.currencyData.orderCurrency;
        this.isVer4Plus = this.topic.topic.version >= this.OPP_VERSION_4;
        //console.log(this.item);
    }
    TableController.prototype.getBonusAmount = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "" + result.amount : 'N/A';
    };
    TableController.prototype.getBonus = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId; });
        return result ? "Bonus " + result.bonus + "%" : 'N/A';
    };
    TableController.prototype.getBonusComment = function (incentiveId) {
        var result = this.data.bonuses.find(function (it) { return it.incentiveType === incentiveId && it.capComment; });
        return result ? result.capComment : undefined;
    };
    TableController.prototype.getSalesOrderLabel = function () {
        switch (this.data.dataType) {
            case LineItemDataType.CTL_SO_24_INC:
                return 'Sales Order (Length of term is up to 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS:
                return 'Sales Order (Length of term is over 24 months)';
            case LineItemDataType.CTL_SO_24_PLUS_ONLY:
                return 'Sales Order (Length of term is over 24 months only)';
            case LineItemDataType.NON_CTL_SO:
                return 'Sales Order (Non CTL SO)';
            default:
                return 'Sales Order';
        }
    };
    TableController.prototype.getUpliftLabel = function () {
        return this.data.baseAmount.isBaseAmount
            ? "Uplifted Amount (ZFN4)"
            : "Uplift (" + this.preferredCurrency + ")";
    };
    TableController.prototype.getUplift = function () {
        return this.data.baseAmount.isBaseAmount ? "" : "Bonus " + this.data.uplift.bonus + "%";
    };
    TableController.prototype.getUpliftAmount = function () {
        return (this.data.baseAmount.isBaseAmount ? this.data.baseAmount.amount : this.data.uplift.amount) || 'N/A';
    };
    TableController.prototype.getBonusLabel = function (incentiveId) {
        switch (incentiveId) {
            case 'sales':
                return (this.isVer4Plus ? 'SSA' : 'CVR SSA') + " (" + this.preferredCurrency + ")";
            case 'engagement':
                return (this.isVer4Plus ? 'Engagement' : 'CVR Solution') + " (" + this.preferredCurrency + ")";
            case 'newClient':
                return "CVR New Client (" + this.preferredCurrency + ")";
            case 'growth':
                return "Growth (" + this.preferredCurrency + ")";
            case 'focus':
                return "Focus (" + this.preferredCurrency + ")";
            case 'ctl':
                return "CTL (" + this.preferredCurrency + ")";
        }
        ;
    };
    TableController.$inject = ['topic'];
    return TableController;
}());
angular
    .module('application')
    .component('paymentTable', new TableComponent());

//# sourceMappingURL=tableController.js.map
